"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsuarioMenuSanduiche = void 0;
var utils_frontend_1 = require("@aura/utils-frontend");
var LftTypography_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftTypography"));
var react_1 = __importDefault(require("react"));
var avatar_1 = require("../avatar");
var line_divider_1 = require("../line-divider");
var usuario_menu_sanduiche_styles_1 = require("./usuario-menu-sanduiche.styles");
var UsuarioMenuSanduiche = function (_a) {
    var nome = _a.nome;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(line_divider_1.LineDividerHor, { margin: '0' }),
        react_1.default.createElement(usuario_menu_sanduiche_styles_1.UsuarioMenuSanduicheStyled, null,
            react_1.default.createElement(avatar_1.Avatar, { size: "md", content: (0, utils_frontend_1.iniciaisFormatter)({ nome: nome, primeiraInicial: true }) }),
            react_1.default.createElement(usuario_menu_sanduiche_styles_1.ConteudoUsuarioMenuSanduicheStyled, null,
                react_1.default.createElement(LftTypography_1.default, { component: "paragraph", size: "small" }, "Ol\u00E1,"),
                react_1.default.createElement(LftTypography_1.default, { component: "paragraph", size: "small", fontWeight: "bold" }, (0, utils_frontend_1.nomeFormatter)(nome)))),
        react_1.default.createElement(line_divider_1.LineDividerHor, { margin: '0' })));
};
exports.UsuarioMenuSanduiche = UsuarioMenuSanduiche;
